import * as types from 'store/modules/hresh1x/mutation-types'
import hresh1x from 'api/hresh1x'
import swal from 'sweetalert'
import hresh1xLabels from 'assets/labels/hresh1x'
import { hresh1xMaxRowspan, hresh1xColumns } from 'assets/columns/hresh1x'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hresh1xLabels,
    maxRowspan: hresh1xMaxRowspan,
    columns: hresh1xColumns(),
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {},
      tab2: {},
      tab3: {
        detail: {},
        table: {
          total: 0,
          rows: []
        }
      }
    },
    indexSelected: {}
  },
  getters: {
    [types.GET_HRESH1X_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRESH1X_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRESH1X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRESH1X_MAX_ROWSPAN] (state) {
      return state.maxRowspan
    },
    [types.GET_HRESH1X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRESH1X_INDEX] (state) {
      return state.index
    },
    [types.GET_HRESH1X_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRESH1X_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRESH1X_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRESH1X_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRESH1X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab3 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab3, labels[keyLang])
      }
    },
    [types.SET_HRESH1X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRESH1X_INDEX] (state, data) {
      state.index = data
    },
    [types.SET_HRESH1X_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRESH1X_DETAIL] (state, data) {
      state.detail = data
    }
  },
  actions: {
    [types.TOGGLE_HRESH1X_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRESH1X_INDEX_DISP, indexDisp)
      commit(types.SET_HRESH1X_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRESH1X_COLUMNS_LABELS] ({ commit }) {
      hresh1x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESH1X_COLUMNS, data.labels)
          commit(types.SET_HRESH1X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRESH1X_INDEX] ({ commit }, searchParams) {
      hresh1x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESH1X_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRESH1X_INDEX, objData)
        })
    },
    [types.RECEIVED_HRESH1X_DETAIL] ({ commit }, searchParams) {
      hresh1x.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRESH1X_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hresh1x/index.js